module.exports = __webpack_public_path__ + "static/media/vip3.9e59ca88.png";